// Accuracy, after Lichess's formula: each move's score is turned into the
// mover's chance of winning, and a move's accuracy falls with how much of
// that chance it gave away. A game's accuracy is the mean of the arithmetic
// and harmonic means of its moves' accuracies, so a few bad moves weigh more
// than an average alone would make them (Lichess also weights by volatility;
// this does not).

/** The mover's chance of winning, 0–100, from their score in pawns. */
export function winPercent(pawns: number): number {
  return 50 + 50 * (2 / (1 + Math.exp(-0.368208 * pawns)) - 1);
}

/** One move's accuracy, 0–100, from the mover's score in pawns before and after it. */
export function moveAccuracy(beforePawns: number, afterPawns: number): number {
  const lost = winPercent(beforePawns) - winPercent(afterPawns);
  if (lost <= 0) return 100;
  return Math.max(0, Math.min(100, 103.1668100711649 * Math.exp(-0.04354415386753951 * lost) - 3.166924740191411));
}

/** A game's accuracy, 0–100, from its moves' accuracies; undefined without any. */
export function gameAccuracy(moves: readonly number[]): number | undefined {
  if (!moves.length) return undefined;
  const mean = moves.reduce((a, b) => a + b, 0) / moves.length;
  // A move at 0 would make the harmonic mean 0 whatever the rest; count it as 1.
  const harmonic = moves.length / moves.reduce((a, b) => a + 1 / Math.max(1, b), 0);
  return (mean + harmonic) / 2;
}
